import { render } from "./StockChanges.vue?vue&type=template&id=39ce2160&scoped=true&ts=true"
import script from "./StockChanges.vue?vue&type=script&lang=ts"
export * from "./StockChanges.vue?vue&type=script&lang=ts"

import "./StockChanges.vue?vue&type=style&index=0&id=39ce2160&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ce2160"]])

export default __exports__